<script setup lang="ts">
defineProps<{
  items?: { title: string; to?: string; href?: string; disabled?: boolean }[]
  divider?: string
}>()

const NuxtLink = defineNuxtLink({})
</script>

<template>
  <nav class="m-breadcrumbs" aria-label="Breadcrumb">
    <ol class="m-breadcrumbs__list">
      <template v-if="items">
        <li v-for="(item, i) in items" :key="i" class="m-breadcrumbs__item">
          <component
            :is="item.to ? NuxtLink : item.href ? 'a' : 'span'"
            v-bind="item.to ? { to: item.to } : item.href ? { href: item.href } : {}"
            class="m-breadcrumbs__link"
            :class="{ 'm-breadcrumbs__link--disabled': item.disabled || i === items.length - 1 }"
          >
            {{ item.title }}
          </component>
          <span v-if="i < items.length - 1" class="m-breadcrumbs__divider">
            {{ divider || '/' }}
          </span>
        </li>
      </template>
      <slot v-else />
    </ol>
  </nav>
</template>

<style scoped>
.m-breadcrumbs__list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0;
  gap: var(--m-space-1);
}

.m-breadcrumbs__item {
  display: flex;
  align-items: center;
  gap: var(--m-space-1);
}

.m-breadcrumbs__link {
  font-size: var(--m-font-size-sm);
  color: var(--m-primary);
  text-decoration: none;
}
.m-breadcrumbs__link:hover { text-decoration: underline; }
.m-breadcrumbs__link--disabled { color: var(--m-on-surface-variant); pointer-events: none; }

.m-breadcrumbs__divider {
  color: var(--m-on-surface-variant);
  font-size: var(--m-font-size-sm);
}
</style>
